export default __webpack_public_path__ + "static/media/visa-mc-logo.2a17d067.png";